import { Component, OnInit } from '@angular/core';

import * as Highcharts from 'highcharts';

import { LicencaService } from 'src/app/licenca/licenca.service';
import { EmpresaService } from 'src/app/empresa/empresa.service';
import { AuthService } from 'src/app/seguranca/auth.service';
import { Licenca } from 'src/app/licenca/licenca.model';
import { ExtratoFilter } from 'src/app/extrato/extrato-filter';
import { ExtratoService } from 'src/app/extrato/extrato.service';

declare var require: any;
const Boost = require('highcharts/modules/boost');
const noData = require('highcharts/modules/no-data-to-display');
const More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'app-estatistica-disponivel',
  templateUrl: './estatistica-disponivel.component.html',
  styleUrls: ['./estatistica-disponivel.component.css']
})
export class EstatisticaDisponivelComponent implements OnInit {

  jwtPayload: any;
  empresasOptions: any[];
  licencasOptions: any[];
  licencas: Licenca[];
  extratoFilter: ExtratoFilter;
  moeda: string;

  public chartDiaOptions: any = {
    title: {
      text: 'Dia do Mês',
      x: 0 // center
    },
    subtitle: {
      text: 'Realizado',
      x: 0
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%e %b'
      }
    },
    yAxis: {
      title: {
        text: 'Valor'
      },
      min: 0,
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    },
    tooltip: {
      valuePrefix: '$'
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      borderWidth: 0
    },
    series: [
      {
        name: 'Disponível',
        data: [],
        pointInterval: 24 * 3600 * 1000 // one day
      }
    ]
  };

  public chartSemanaOptions: any = {
    chart: {
      type: 'column'
    },
    title: {
      text: 'Dia da Semana',
      x: 0
    },
    subtitle: {
      text: 'Realizado',
      x: 0
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: [
        'Domingo',
        'Segunda Feira',
        'Terça Feira',
        'Quarta Feira',
        'Quinta Feira',
        'Sexta Feira',
        'Sábado'
      ]
    },
    yAxis: {
      title: {
        text: 'Valor'
      },
      min: 0,
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    },
    tooltip: {
      valuePrefix: '$'
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      borderWidth: 0
    },
    series: [
      { name: 'Disponível', data: [] }
    ]
  };

  constructor(
    private authService: AuthService,
    private empresaService: EmpresaService,
    private licencaService: LicencaService,
    private extratoService: ExtratoService
  ) { }

  ngOnInit() {
    this.jwtPayload = this.authService.getJwtPayload();

    this.extratoFilter = new ExtratoFilter(this.jwtPayload.usuarioEmpresaId);
    this.moeda = undefined;

    this.empresaService.getEmpresas().subscribe(
      empresas => {
        this.empresasOptions = [];
        empresas.forEach(empresa => {
          let name = empresa.nomeFantasia;
          if (empresa.type === 'PF') {
            name = empresa.razaoSocial + ' ' + name;
          } else {
            name = empresa.razaoSocial + ' | ' + name;
          }
          this.empresasOptions.push(
            { label: name.toUpperCase(), value: empresa.id, ativa: empresa.ativa }
          );
        });
      },
      err => {
        console.log('Error:', err);
      },
      () => {
        this.empresasOptions.sort(function (a, b) {
          if (a.label > b.label) {
            return 1;
          }
          if (a.label < b.label) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        this.buscarLicencas();
      }
    );

  }

  buscarLicencas() {
    this.extratoFilter.licencaId = undefined;
    this.licencaService.buscarPorEmpresa(this.extratoFilter.empresaId).subscribe(
      licencas => {
        this.licencas = licencas;
        this.licencasOptions = [];
        for (let licenca of licencas) {
          if (this.extratoFilter.empresaId === this.jwtPayload.usuarioEmpresaId && this.jwtPayload.licencasPermitidas.length > 0 && !this.jwtPayload.licencasPermitidas.includes(licenca.id)) {
            continue;
          }
          this.licencasOptions.push(
            { label: `${licenca.contrato} [${licenca.moeda}]`, value: licenca.id, moeda: licenca.moeda }
          );
          if (this.extratoFilter.licencaId === undefined) {
            this.extratoFilter.licencaId = licenca.id;
          }
        }
      },
      err => console.log('Error:', err)
    );
  }

  buscar() {
    this.licencas.forEach(
      licenca => {
        if (licenca.id === this.extratoFilter.licencaId) {
          this.moeda = licenca.moeda;
        }
      }
    );

    this.extratoService.getCreditosDia(this.extratoFilter).subscribe(
      result => {
        this.chartDiaOptions.series[0].data = [];
        this.chartSemanaOptions.series[0].data = [];
        if (result.length > 0) {
          this.chartDiaOptions.tooltip.valuePrefix = this.moeda === 'BRL' ? 'R$ ' : '$';
          this.chartSemanaOptions.tooltip.valuePrefix = this.moeda === 'BRL' ? 'R$ ' : '$';
          this.chartSemanaOptions.series[0].data = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
          const d: number = parseInt(result[0].dt.substring(8), 10);
          const m: number = parseInt(result[0].dt.substring(5, 7), 10);
          const a: number = parseInt(result[0].dt.substring(0, 4), 10);
          const dtInit = Date.UTC(a, m - 1, d);
          this.chartDiaOptions.series[0].pointStart = dtInit;
          for (const value of result) {
            let dt = new Date(value.dt);
            this.chartSemanaOptions.series[0].data[dt.getUTCDay()] += value.totalLiquidado;
            this.chartDiaOptions.series[0].data.push(value.totalLiquidado);
          }
        }
        Highcharts.chart('chart-disponivel-dia', this.chartDiaOptions);
        Highcharts.chart('chart-disponivel-semana', this.chartSemanaOptions);
      },
      err => {
        console.log('Error:', err);
      }
    );
  }

  hasPermission(permission: string) {
    return this.jwtPayload.authorities.includes(permission);
  }

}
